module.exports = __webpack_public_path__ + "static/media/fetal-id-education-color.34f4b1ef.png";